<template>
  <Plan
    is-pro
    title="Pro+"
    description="Looking to take your bio links to the next level? Look no further."
    :price="price"
    :price-description="`USD per ${interval}`"
    :features="FEATURES"
  >
    <template v-if="!$slots.actions" #actions>
      <slot name="actions" />
    </template>

    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />
  </Plan>
</template>

<script>
import Plan from './plan';

const FEATURES = [
  {
    title: 'All of the Pro features',
  },
  {
    title: 'Get six profiles out of the box',
  },
  {
    title: 'Add your team with four collaborators',
  },
  {
    title: 'View lifetime analytics for all of your profiles',
  },
  {
    title:
      'Analyze your profile traffic in depth with our reporting tools and filtering',
  },
  {
    title: 'Export your analytics data as a .csv',
  },
];

export default {
  components: {
    Plan,
  },

  props: {
    price: {
      type: String,
      required: true,
    },

    interval: {
      type: String,
      default: 'month',
    },
  },

  setup() {
    return {
      FEATURES,
    };
  },
};
</script>

<style lang="scss" scoped></style>
